import { render, staticRenderFns } from "./verticalBannerView.vue?vue&type=template&id=a8b44c50&scoped=true&"
import script from "./verticalBannerView.vue?vue&type=script&lang=js&"
export * from "./verticalBannerView.vue?vue&type=script&lang=js&"
import style0 from "./verticalBannerView.vue?vue&type=style&index=0&id=a8b44c50&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b44c50",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,ALink: require('/app/components/aLink.vue').default,ObserverHOC: require('/app/components/ObserverHOC/index.vue').default})
